<script setup lang="ts">
import Header from '@/layouts/header/ColorHeader.vue';
import JobsGrid from '@/components/pages/jobs/jobs-grid/Index.vue'
import DontMiss from '@/components/pages/jobs/jobs-grid/DontMiss.vue';
import Footer from '@/layouts/footer/nftFooter.vue';

</script>
<template>
    <!--Header-->
    <Header />
        <JobsGrid/>
        <DontMiss/>
    <Footer />
</template>